import React from "react";
import { connect } from "react-redux";
import { deleteGroup } from "actions/groups";
import messages from "utils/messages";

class ConfirmDeleteGroupModal extends React.Component {
  confirm() {
    this.props.dispatch(deleteGroup(this.props.group.id));
    this.props.onHide();
  }

  render() {
    const hasHabits = this.props.group?.numHabits > 0;
    const message = hasHabits
      ? messages.DELETE_NON_EMPTY_GROUP
      : messages.CONFIRM_DELETE_GROUP_TEXT;

    return (
      <div className="confirm-delete-modal">
        <div className="modal-body">{message}</div>
        <div className="modal-footer">
          {!hasHabits && (
            <a className="modal-button" onClick={this.confirm.bind(this)}>
              {messages.DELETE}
            </a>
          )}
          <a className="modal-button cancel" onClick={this.props.onHide}>
            {messages.CANCEL}
          </a>
        </div>
      </div>
    );
  }
}

export default connect((state, props) => ({
  group: state.groupsEntities[props.group.id],
}))(ConfirmDeleteGroupModal);
